import { zodResolver } from '@hookform/resolvers/zod';
import { Stack } from '@mantine/core';
import type { ComponentProps, ElementType, ReactNode } from 'react';
import { useForm } from 'react-hook-form';
import type { FieldValues, SubmitHandler } from 'react-hook-form';
import type { z, ZodType } from 'zod';

interface FormProps<FormContentElement extends ElementType, ZodSchema extends ZodType<FieldValues, FieldValues>> {
  schema: ZodSchema;
  defaultValues: z.infer<ZodSchema>;
  onSubmit: SubmitHandler<z.infer<ZodSchema>>;
  formContentElement: FormContentElement;
  buttonSlot: ReactNode;
}

export const Form = <FormContentElement extends ElementType, ZodSchema extends ZodType<FieldValues, FieldValues>>({
  schema,
  defaultValues,
  onSubmit,
  formContentElement,
  buttonSlot,
}: FormProps<FormContentElement, ZodSchema>) => {
  const formMethods = useForm({
    resolver: zodResolver(schema),
    defaultValues,
    mode: 'onTouched',
  });

  const ContentElement = formContentElement;

  const contentProps = {
    useFormValue: formMethods,
  } as ComponentProps<FormContentElement>;

  return (
    // @ts-expect-error suppressing TypeScript error due to unrecognized form type on Stack component
    <Stack noValidate component="form" gap="md" onSubmit={(event) => void formMethods.handleSubmit(onSubmit)(event)}>
      <ContentElement {...contentProps} />
      {buttonSlot}
    </Stack>
  );
};
